// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__drG9S"};